export const GET_POSTS = "GET_POSTS";
export const APPROVE_POST = "APPROVE_POST";
export const FLAG_POST = "FLAG_POST";
export const REJECT_POST = "REJECT_POST"